import { useState } from "react";
import { Table, Tag, Dropdown, Button, Space, Typography, Tooltip, Menu } from "antd";
import {
  CarOutlined,
  ApartmentOutlined,
  UserOutlined,
  EnvironmentOutlined,
  TrademarkOutlined,
  AppstoreOutlined,
  DownOutlined,
  MenuOutlined,
  FileTextOutlined
} from "@ant-design/icons";
import moment from "moment";
import { ChronoTag, EcartTag, MoyenneTag, renderDateTag } from "../../../../utils/renderTooltip";

const { Text } = Typography;

const renderTextWithTooltip = (text, maxWidth = 160) => (
  <Tooltip title={text}>
    <div
      style={{
        maxWidth,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      <Text type="secondary">{text}</Text>
    </div>
  </Tooltip>
);

export const getDurationColor = (elapsedMinutes, datePrevue) => {
  if (!datePrevue) return "default";

  const diff = moment().diff(moment(datePrevue), "minutes");

  if (diff <= 0) return "green";
  if (diff > 25 && diff <= 60) return "orange";
  if (diff > 60) return "red";
  return "green";
};


const RapportVehiculeCourses = ({ course }) => {
  const [columnsVisibility, setColumnsVisibility] = useState({
        '#': true,
        'Motif': true,
        'Service': true,
        'Chauffeur': true,
        'Destination' : true,
        'Type véhicule' : true,
        'Immatriculation' : false,
        'Marque' : false,
        'Retour prévu' : true,
        'Durée': true,
        'Durée moyenne' : true, 
        'Écart' : true,
        'Commentaire': false
  });

  const columns = [
    { title: "#", key: "index", render: (_, __, index) => index + 1, width: 50 },
    {
      title: (
        <Space>
          <AppstoreOutlined style={{ color: "#1890ff" }} />
          <Text strong>Motif</Text>
        </Space>
      ),
      dataIndex: "nom_motif_demande",
      key: "nom_motif_demande",
      render: (text) => renderTextWithTooltip(text),
        ...(columnsVisibility['Motif'] ? {} : { className: 'hidden-column' })
    },
    {
      title: (
        <Space>
          <ApartmentOutlined style={{ color: "#1d39c4" }} />
          <Text strong>Service</Text>
        </Space>
      ),
      dataIndex: "nom_service",
      key: "nom_service",
      render: (text) => renderTextWithTooltip(text),
        ...(columnsVisibility['Service'] ? {} : { className: 'hidden-column' })
    },
    {
      title: (
        <Space>
          <UserOutlined style={{ color: "orange" }} />
          <Text strong>Chauffeur</Text>
        </Space>
      ),
      dataIndex: "nom",
      key: "nom",
      render: (_, record) =>
        renderTextWithTooltip(`${record.prenom_chauffeur} ${record.nom}`),
        ...(columnsVisibility['Chauffeur'] ? {} : { className: 'hidden-column' })
    },
    {
      title: (
        <Space>
          <EnvironmentOutlined style={{ color: "red" }} />
          <Text strong>Destination</Text>
        </Space>
      ),
      dataIndex: "nom_destination",
      key: "nom_destination",
      render: (text) => renderTextWithTooltip(text),
        ellipsis: true,
        ...(columnsVisibility['Destination'] ? {} : { className: 'hidden-column' })
    },
    {
      title: (
        <Space>
          <CarOutlined style={{ color: "green" }} />
          <Text strong>Véhicule</Text>
        </Space>
      ),
      dataIndex: "nom_cat",
      key: "nom_cat",
      render: (text) => renderTextWithTooltip(text),
        ...(columnsVisibility['Type véhicule'] ? {} : { className: 'hidden-column' })
    },
    {
      title: "Immatriculation",
      dataIndex: "immatriculation",
      key: "immatriculation",
      render: (text) => <Tag color="magenta">{text}</Tag>,
        ...(columnsVisibility['Immatriculation'] ? {} : { className: 'hidden-column' })
    },
    {
      title: "Marque",
      dataIndex: "nom_marque",
      key: "nom_marque",
      render: (text) => (
        <Tag icon={<TrademarkOutlined />} color="blue">
          {text}
        </Tag>
      ),
        ...(columnsVisibility['Marque'] ? {} : { className: 'hidden-column' })
    },
    {
      title: 'Retour prévu',
      dataIndex:'date_retour',
      key:'date_retour',
      align: 'center',
      render: (text) => renderDateTag(text),
        ...(columnsVisibility['Retour prévu'] ? {} : { className: 'hidden-column' })
    },
    {
      title: "Durée R.",
      key: "duree_reelle_min",
      render: (_, record) => (
        <ChronoTag sortie_time={record.sortie_time} date_prevue={record.date_prevue} />
      ),
        ...(columnsVisibility['Durée'] ? {} : { className: 'hidden-column' })
    },
    {
      title: "Durée M.",
      key: "duree_moyenne_min",
      render: (_, record) => <MoyenneTag duree_moyenne_min={record.duree_moyenne_min} />,
        ...(columnsVisibility['Durée moyenne'] ? {} : { className: 'hidden-column' })
    },
    {
      title: "Écart",
      key: "ecart_min",
      render: (_, record) => (
        <EcartTag
          duree_reelle_min={record.duree_reelle_min}
          duree_moyenne_min={record.duree_moyenne_min}
        />
      ),
          ...(columnsVisibility['Écart'] ? {} : { className: 'hidden-column' })
    },
        {
      title: <Space><FileTextOutlined style={{ color:'orange' }} /><Text strong>Commentaire</Text></Space>,
      key:'commentaire',
      render: (_, record) => renderTextWithTooltip(`${record.commentaire}`),
      ellipsis: true,
        ...(columnsVisibility['Commentaire'] ? {} : { className: 'hidden-column' })
    }
  ];

  const toggleColumnVisibility = (columnName, e) => {
    e.stopPropagation();
    setColumnsVisibility(prev => ({
      ...prev,
      [columnName]: !prev[columnName]
    }));
  };

  const menus = (
    <Menu>
      {Object.keys(columnsVisibility).map(columnName => (
        <Menu.Item key={columnName}>
          <span onClick={(e) => toggleColumnVisibility(columnName,e)}>
            <input type="checkbox" checked={columnsVisibility[columnName]} readOnly />
            <span style={{ marginLeft: 8 }}>{columnName}</span>
          </span>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="rapportVehiculeValide">
      <div className="colonne-filtre">
          <Dropdown overlay={menus} trigger={['click']} placement="bottomRight" arrow>
            <Button
              icon={<MenuOutlined />}
              className="colonne-filtre-btn"
              type="primary"
            >
              Colonnes <DownOutlined />
            </Button>
          </Dropdown>
      </div>

      <Table
        columns={columns}
          dataSource={course}
          rowKey={(record) => record.id_vehicule}
          pagination={{ pageSize: 15 }}
          scroll={{ x: "max-content" }}
          bordered
          size="middle"
        rowClassName={(record, index) => (index % 2 === 0 ? 'odd-row' : 'even-row')}
      />
    </div>
  );
};

export default RapportVehiculeCourses;
